import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://kcwaqseendhxbsnpmlkg.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtjd2Fxc2VlbmRoeGJzbnBtbGtnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE5MzMzNzYsImV4cCI6MjA5NzUwOTM3Nn0.hQLzlzzFyF-Iw-1FVsxMWX3Avi3GPQmTocSsWmsINqw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
